import { render } from "./assessment-mobile.vue?vue&type=template&id=4d84801a&scoped=true&ts=true"
import script from "./assessment-mobile.vue?vue&type=script&lang=ts"
export * from "./assessment-mobile.vue?vue&type=script&lang=ts"

import "./assessment-mobile.vue?vue&type=style&index=0&id=4d84801a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d84801a"]])

export default __exports__